// =============================================================================
// useCanAccessSideprojects — czy zalogowany user ma dostęp do workspace 'sideprojects'
// =============================================================================
// Źródło prawdy: RPC can_access_sideprojects() (flaga w allowed_users). DB-driven,
// więc dopisanie kogoś = UPDATE bez deployu. Deny-by-default (loading/błąd = brak).
// Ta sama flaga steruje RLS na thematic_maps + websites (migracja
// 20260722_sideprojects_access_control.sql), więc front i baza są spójne.

import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useCanAccessSideprojects() {
  const [canAccess, setCanAccess] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        // RPC nie ma w auto-typach — cast (wzorzec (supabase as any) z CLAUDE.md)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { data, error } = await (supabase as any).rpc("can_access_sideprojects");
        if (cancelled) return;
        setCanAccess(!error && data === true);
      } catch {
        if (!cancelled) setCanAccess(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { canAccess, loading: canAccess === null };
}
